import React from "react";
import ReactDOM from "react-dom";
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import mq from "./helpers/media-queries";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import TiemposHeadlineWoff from './assets/fonts/TiemposHeadline.woff';
import TiemposHeadlineWoff2 from './assets/fonts/TiemposHeadline.woff2';

const GlobalStyle = createGlobalStyle`
  ${reset}

  @font-face {
    font-family: 'Tiempos Headline';
    src: url(${TiemposHeadlineWoff2}) format('woff2'),
    url(${TiemposHeadlineWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  * { box-sizing: border-box; }

  ${mq("sm", "min")} {
    #rt-configurator {
      height: 100vh;
    }
  }
`;

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <GlobalStyle />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("rt-configurator")
);
